// extracted by mini-css-extract-plugin
export var AllergensDecorator = "index-module--AllergensDecorator--ea9df";
export var ColumnFlexLayout = "index-module--ColumnFlexLayout--fb546";
export var GiftIcon = "index-module--GiftIcon--d6e9d";
export var HideOnDesktop = "index-module--HideOnDesktop--0529a";
export var HideOnMobile = "index-module--HideOnMobile--10f22";
export var Image = "index-module--Image--3c4e9";
export var LockClosedIcon = "index-module--LockClosedIcon--8ebec";
export var LockOpenFlag = "index-module--LockOpenFlag--81eb1";
export var LockOpenIcon = "index-module--LockOpenIcon--639ef";
export var LockedDealImage = "index-module--LockedDealImage--e5892";
export var LockedDisplay = "index-module--LockedDisplay--ba09a";
export var LockedItemOverlay = "index-module--LockedItemOverlay--5e29e";
export var MenuItemLoader = "index-module--MenuItemLoader--7f1e7";
export var MenuItemTitle = "index-module--MenuItemTitle--6e8da";
export var RTL = "index-module--RTL--bda32";
export var Row = "index-module--Row--7e3de";
export var RowFlexLayout = "index-module--RowFlexLayout--2668d";
export var RowLayout = "index-module--RowLayout--49b8d";
export var RowNoFade = "index-module--RowNoFade--9cff4";
export var Unlocked = "index-module--Unlocked--d8e2a";
export var UnlockedDealImage = "index-module--UnlockedDealImage--b7cef";
export var Wrapper = "index-module--Wrapper--2a265";
export var deblur = "index-module--deblur--41a33";
export var flickerAnimation = "index-module--flickerAnimation--f6db8";
export var lighten = "index-module--lighten--bc1a3";
export var unlock = "index-module--unlock--85476";